// Full service catalog with images, pricing per vehicle and descriptions.
// Images sourced from Unsplash (transportation, Yucatan destinations).

export const catalog = {
  en: [
    {
      id: "airport-oneway",
      category: "Airport Transfer",
      name: "One-Way Airport Transfer",
      tagline: "CUN Airport → Anywhere in the zone",
      image:
        "https://images.unsplash.com/photo-1553260168-69b041873e65?w=1600&q=80",
      description:
        "Skip the taxi lines and the shared shuttle stops. A uniformed driver waits at arrivals with a sign bearing your name, helps with luggage, and drives you directly to your hotel — anywhere from Cancún Hotel Zone to Tulum. Bottled water, Wi-Fi and flight tracking included.",
      duration: "45 min – 2 hr depending on destination",
      includes: ["Meet & greet at arrivals", "Bottled water on board", "Free flight tracking", "No hidden fees"],
      prices: { suv: 75, van: 110, luxury: 180 },
    },
    {
      id: "airport-roundtrip",
      category: "Airport Transfer",
      name: "Round-Trip Transfer",
      tagline: "Arrival + Departure with the same team",
      image:
        "https://customer-assets-m6fa6gv7.emergentagent.net/job_riviera-transport-2/artifacts/ivv30d2i_image.png",
      description:
        "The most popular choice for peace of mind. We pick you up at the airport, we bring you back on time for your flight. Same trusted driver whenever possible, priority booking during peak hours, and a discount compared to two one-way transfers.",
      duration: "Both legs of your trip",
      includes: ["Same-team pick-up & drop-off", "Priority scheduling", "Save vs 2 one-ways", "24/7 support"],
      prices: { suv: 140, van: 200, luxury: 340 },
    },
    {
      id: "tour-chichen",
      category: "Private Tour",
      name: "Chichén Itzá Full-Day Tour",
      tagline: "One of the Seven Wonders of the World",
      image:
        "https://images.unsplash.com/photo-1750942725387-3485cf0c9d7b?w=1600&q=80",
      description:
        "Explore the iconic Kukulcán pyramid, the ball court and the sacred cenote at your own pace with an English or Spanish speaking driver-guide. Includes a stop at a colonial town for lunch (not included) and a swim in a cenote on the way back.",
      duration: "10–12 hours",
      includes: ["Private vehicle & driver", "Cenote swim stop", "Colonial town lunch stop", "Entrance tickets guidance"],
      prices: { suv: 320, van: 420, luxury: 580 },
    },
    {
      id: "tour-tulum",
      category: "Private Tour",
      name: "Tulum Ruins & Cenotes",
      tagline: "Mayan history by the Caribbean sea",
      image:
        "https://customer-assets-m6fa6gv7.emergentagent.net/job_riviera-transport-2/artifacts/gvxiy5yj_image.webp",
      description:
        "Visit the cliff-side Tulum archaeological site overlooking turquoise water, then dive into one of the region's crystal-clear cenotes. Perfect half-day escape from the resort with plenty of time to relax.",
      duration: "6–8 hours",
      includes: ["Tulum ruins visit", "1–2 cenotes stop", "Free bottled water", "Flexible schedule"],
      prices: { suv: 220, van: 300, luxury: 420 },
    },
    {
      id: "tour-xcaret",
      category: "Theme Park",
      name: "Xcaret / Xel-Há / Xplor Transfer",
      tagline: "Skip the shuttle — arrive fresh",
      image:
        "https://customer-assets-m6fa6gv7.emergentagent.net/job_riviera-transport-2/artifacts/hvq812m3_image.png",
      description:
        "Round-trip private transfer to any of the Xcaret group parks. We drop you at the entrance and pick you up whenever you're ready — no waiting in a hot bus, no shared stops. Ideal for families with strollers or gear.",
      duration: "Full-day, park hours",
      includes: ["Door-to-park pick-up", "Wait time included", "Family friendly", "Stroller & gear space"],
      prices: { suv: 180, van: 260, luxury: 360 },
    },
    {
      id: "tour-coba",
      category: "Private Tour",
      name: "Cobá Ruins Adventure",
      tagline: "Climb the tallest pyramid still open",
      image:
        "https://images.unsplash.com/photo-1769105278700-d40ffa5adb9a?w=1600&q=80",
      description:
        "A less-crowded jungle site where you can still explore by bike or rickshaw. Combine with a swim at a nearby cenote and lunch in a Mayan village for a full day off the beaten path.",
      duration: "8–10 hours",
      includes: ["Cobá jungle ruins", "Optional bike/rickshaw stop", "Cenote swim", "Mayan village lunch stop"],
      prices: { suv: 280, van: 380, luxury: 500 },
    },
    {
      id: "tour-isla",
      category: "Private Tour",
      name: "Isla Mujeres Day",
      tagline: "Ferry drop-off + island tour",
      image:
        "https://customer-assets-m6fa6gv7.emergentagent.net/job_riviera-transport-2/artifacts/6q4gbv86_image.png",
      description:
        "We take you to the Puerto Juárez ferry terminal, help you board, and pick you up when you return. Optional pre-booked golf cart on the island for an all-day adventure. Perfect for couples and small groups.",
      duration: "Full-day flexible",
      includes: ["Ferry terminal transfer", "Return pick-up", "Optional golf-cart booking", "Reef snorkel guidance"],
      prices: { suv: 140, van: 200, luxury: 300 },
    },
    {
      id: "tour-bacalar",
      category: "Private Tour",
      name: "Bacalar — The Lagoon of Seven Colors",
      tagline: "Hidden gem, 3.5 hr south",
      image:
        "https://customer-assets-m6fa6gv7.emergentagent.net/job_riviera-transport-2/artifacts/u1dwfo20_image.png",
      description:
        "Escape the crowds and spend the day at one of Mexico's most stunning fresh-water lagoons. Long drive, but we make it comfortable — cold drinks, playlists on request, and stops whenever you need.",
      duration: "12–14 hours",
      includes: ["Comfort long-haul vehicle", "Cold drinks on board", "Flexible stops", "Boat tour booking help"],
      prices: { suv: 420, van: 560, luxury: 780 },
    },
  ],
  es: [
    {
      id: "airport-oneway",
      category: "Traslado Aeropuerto",
      name: "Traslado Sencillo desde el Aeropuerto",
      tagline: "Aeropuerto CUN → cualquier hotel",
      image:
        "https://images.unsplash.com/photo-1553260168-69b041873e65?w=1600&q=80",
      description:
        "Olvídate de la fila del taxi y las paradas de la van compartida. Un chofer uniformado te espera en llegadas con un cartel con tu nombre, te ayuda con las maletas y te lleva directo a tu hotel — desde la Zona Hotelera de Cancún hasta Tulum. Incluye agua embotellada, Wi-Fi y monitoreo de vuelo.",
      duration: "45 min – 2 hr según destino",
      includes: ["Recepción en llegadas", "Agua embotellada a bordo", "Monitoreo de vuelo gratis", "Sin cargos ocultos"],
      prices: { suv: 75, van: 110, luxury: 180 },
    },
    {
      id: "airport-roundtrip",
      category: "Traslado Aeropuerto",
      name: "Traslado Redondo",
      tagline: "Llegada + Salida con el mismo equipo",
      image:
        "https://customer-assets-m6fa6gv7.emergentagent.net/job_riviera-transport-2/artifacts/ivv30d2i_image.png",
      description:
        "La opción más popular para viajar sin preocupaciones. Te recogemos en el aeropuerto y te llevamos de vuelta con tiempo para tu vuelo. Mismo chofer cuando es posible, prioridad en horarios pico y descuento vs dos sencillos.",
      duration: "Ambos trayectos del viaje",
      includes: ["Mismo equipo ida y vuelta", "Prioridad de horario", "Ahorra vs 2 sencillos", "Soporte 24/7"],
      prices: { suv: 140, van: 200, luxury: 340 },
    },
    {
      id: "tour-chichen",
      category: "Tour Privado",
      name: "Chichén Itzá — Día Completo",
      tagline: "Una de las Siete Maravillas del Mundo",
      image:
        "https://images.unsplash.com/photo-1750942725387-3485cf0c9d7b?w=1600&q=80",
      description:
        "Explora la icónica pirámide de Kukulcán, el juego de pelota y el cenote sagrado a tu ritmo, acompañado por un chofer-guía bilingüe. Incluye una parada en un pueblo colonial para almorzar (no incluido) y un baño en un cenote de regreso.",
      duration: "10–12 horas",
      includes: ["Vehículo y chofer privado", "Baño en cenote", "Parada en pueblo colonial", "Asesoría con entradas"],
      prices: { suv: 320, van: 420, luxury: 580 },
    },
    {
      id: "tour-tulum",
      category: "Tour Privado",
      name: "Tulum: Ruinas y Cenotes",
      tagline: "Historia maya frente al mar Caribe",
      image:
        "https://customer-assets-m6fa6gv7.emergentagent.net/job_riviera-transport-2/artifacts/gvxiy5yj_image.webp",
      description:
        "Visita el sitio arqueológico de Tulum sobre acantilados con vista al mar turquesa, y luego sumérgete en uno de los cenotes cristalinos de la zona. Escapada perfecta de medio día del resort con tiempo para relajarte.",
      duration: "6–8 horas",
      includes: ["Ruinas de Tulum", "1–2 cenotes", "Agua embotellada gratis", "Horario flexible"],
      prices: { suv: 220, van: 300, luxury: 420 },
    },
    {
      id: "tour-xcaret",
      category: "Parque Temático",
      name: "Xcaret / Xel-Há / Xplor — Traslado",
      tagline: "Sáltate la van compartida",
      image:
        "https://customer-assets-m6fa6gv7.emergentagent.net/job_riviera-transport-2/artifacts/hvq812m3_image.png",
      description:
        "Traslado privado redondo a cualquier parque del grupo Xcaret. Te dejamos en la entrada y regresamos cuando estés listo — sin esperar en autobuses calientes ni paradas compartidas. Ideal para familias con carriolas o equipo.",
      duration: "Día completo, horario del parque",
      includes: ["Recogida puerta a parque", "Tiempo de espera incluido", "Ideal en familia", "Espacio para carriola"],
      prices: { suv: 180, van: 260, luxury: 360 },
    },
    {
      id: "tour-coba",
      category: "Tour Privado",
      name: "Aventura en Cobá",
      tagline: "Escala la pirámide más alta abierta",
      image:
        "https://images.unsplash.com/photo-1769105278700-d40ffa5adb9a?w=1600&q=80",
      description:
        "Un sitio en la selva con menos multitudes donde aún puedes recorrer en bicicleta o rickshaw. Combínalo con un baño en un cenote cercano y comida en un pueblo maya para un día fuera de la ruta turística.",
      duration: "8–10 horas",
      includes: ["Ruinas de Cobá en la selva", "Bicicleta/rickshaw opcional", "Cenote", "Almuerzo en pueblo maya"],
      prices: { suv: 280, van: 380, luxury: 500 },
    },
    {
      id: "tour-isla",
      category: "Tour Privado",
      name: "Día en Isla Mujeres",
      tagline: "Traslado al ferry + apoyo en la isla",
      image:
        "https://customer-assets-m6fa6gv7.emergentagent.net/job_riviera-transport-2/artifacts/6q4gbv86_image.png",
      description:
        "Te llevamos al muelle de Puerto Juárez, te ayudamos a abordar y te recogemos al regresar. Opción de golf-cart prebooked en la isla para todo el día. Perfecto para parejas y grupos pequeños.",
      duration: "Día flexible",
      includes: ["Traslado al muelle", "Recogida de regreso", "Golf-cart opcional", "Asesoría de snorkel"],
      prices: { suv: 140, van: 200, luxury: 300 },
    },
    {
      id: "tour-bacalar",
      category: "Tour Privado",
      name: "Bacalar — Laguna de los Siete Colores",
      tagline: "Joya escondida a 3.5 hrs al sur",
      image:
        "https://customer-assets-m6fa6gv7.emergentagent.net/job_riviera-transport-2/artifacts/u1dwfo20_image.png",
      description:
        "Escapa de las multitudes y pasa el día en una de las lagunas de agua dulce más impresionantes de México. El viaje es largo, pero lo hacemos cómodo — bebidas frías, playlists a pedido y paradas cuando lo necesites.",
      duration: "12–14 horas",
      includes: ["Vehículo de largo trayecto", "Bebidas frías a bordo", "Paradas flexibles", "Reserva del paseo en lancha"],
      prices: { suv: 420, van: 560, luxury: 780 },
    },
  ],
};

export const catalogLabels = {
  en: {
    eyebrow: "OUR CATALOG",
    title: "Every route, every experience.",
    subtitle:
      "Private transportation and curated tours across the Yucatán Peninsula. All prices in USD.",
    duration: "Duration",
    includes: "What's included",
    from: "From",
    perVehicle: "USD · per vehicle",
    suv: "Executive SUV",
    van: "Sprinter Van",
    luxury: "Luxury Sedan",
    bookNow: "Reserve this service",
    filterAll: "All",
    backHome: "Home",
  },
  es: {
    eyebrow: "NUESTRO CATÁLOGO",
    title: "Cada ruta, cada experiencia.",
    subtitle:
      "Transporte privado y tours curados por toda la Península de Yucatán. Todos los precios en USD.",
    duration: "Duración",
    includes: "Qué incluye",
    from: "Desde",
    perVehicle: "USD · por vehículo",
    suv: "SUV Ejecutiva",
    van: "Sprinter Van",
    luxury: "Sedán de Lujo",
    bookNow: "Reservar este servicio",
    filterAll: "Todos",
    backHome: "Inicio",
  },
};
